import React, { useEffect, useState, useMemo, useRef } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { useDebounce } from 'use-debounce'
import { QuickSearchMapping } from './quick-search-builder'
import Icon from '@c/icon'

import './index.css'

/**
 *
 * @param {{mappings: QuickSearchMapping[]}} props
 * @returns
 */
function QuickSearch(props) {
  const [inputString, setInputString] = useState('')
  const [queryString] = useDebounce(inputString, 500)
  const [result, setResult] = useState([])
  const [hideResult, setHideResult] = useState(false)
  const showResult = useMemo(
    () => !!queryString?.trim().length && !!result?.length && !hideResult,
    [queryString, result, hideResult]
  )
  const ref = useRef(null)
  useEffect(() => {
    const r = []
    props.mappings.forEach(mapping =>
      r.push(...mapping.search.search(queryString))
    )
    setResult(r)
  }, [queryString])
  const supportsTouch =
    (typeof window !== 'undefined' && 'ontouchstart' in window) ||
    (typeof navigator !== 'undefined' && navigator?.msMaxTouchPoints)
  useEffect(() => {
    const handleCloseMenu = event =>
      ref.current && !ref.current.contains(event.target) && setHideResult(true)
    document.addEventListener('mousedown', handleCloseMenu)
    return () => document.removeEventListener('mousedown', handleCloseMenu)
  }, [ref])
  return (
    <div
      className="quick-search d-flex align-items-end flex-wrap flex-lg-nowrap"
      ref={ref}
      onMouseLeave={() => !supportsTouch && setHideResult(false)}
      style={props.style}
    >
      <div className="cntf">
        <div className="d-flex align-items-center cntf">
          <Icon className="quick-search-img" name="search" />
          <input
            onFocus={() => setHideResult(false)}
            className="quick-search-input"
            onChange={ev => setInputString(ev.target.value)}
          />
        </div>
        <nav className="result">
          <div
            className={classNames({
              'result-box': true,
              'd-none': !showResult
            })}
          >
            {result.map(o => (
              <div key={o?.buildedUrl}>
                <Link className="result-link" to={o.buildedUrl}>
                  {o.buildedTitle}
                </Link>
              </div>
            ))}
          </div>
        </nav>
      </div>
    </div>
  )
}
QuickSearch.propTypes = {
  mappings: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.instanceOf(QuickSearchMapping)
    })
  )
}

export default QuickSearch
